import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { LocalizedStringRecord } from "../../app/slices/TrainingLocalizationSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import SubSequenceNodePreview from "../../features/sequence/node_previews/SubSequenceNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import { Prop } from "../Prop";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  getBooleanSearchLabels,
} from "./SearchableInteractionValues";

export interface ISubSequence extends Interaction {
  finishAll: boolean;
  sequenceName: string;
  abortOthersOnFinish: boolean;
}

export const subSequenceInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): ISubSequence => {
    return {
      id: GetNewGuid(),
      name: "Sub Sequence",
      type: InteractionType.SubSequence,
      finishAll: true,
      sequenceName: "Sub Sequence",
      abortOthersOnFinish: false,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): ISubSequence => {
    return interaction as ISubSequence;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): ISubSequence => {
    const converted = interaction as ISubSequence;
    return {
      id: GetNewGuid(),
      name: converted.name,
      type: InteractionType.SubSequence,
      finishAll: converted.finishAll,
      sequenceName: converted.sequenceName,
      abortOthersOnFinish: converted.abortOthersOnFinish,
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const filterType = "Sub Sequence";

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as ISubSequence;
    return getMatchingResults(
      compactSearchableStrings(
        interaction.name,
        converted.sequenceName,
        getBooleanSearchLabels(
          converted.finishAll,
          "Finish All",
          "Do Not Finish All",
        ),
        getBooleanSearchLabels(
          converted.abortOthersOnFinish,
          "Abort Others On Finish",
          "Do Not Abort Others On Finish",
        ),
      ),
      takeName,
      interaction,
      filterType
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[],
    allPropPresets: Prop[],
    localizedStringRecords: LocalizedStringRecord
  ): string[] => {
    const subSequence = interaction as ISubSequence;
    const errors: string[] = [];

    if (!subSequence.sequenceName?.trim()) {
      errors.push("Sub sequence name is required");
    }

    return errors;
  };

  return {
    View: <></>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <SubSequenceNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
    FilterType: filterType,
  };
};
